import Vue from 'vue'
import { Keyboard } from '@/models'
import OverviewTab from './OverviewTab.vue'
import DeactivateTab from './DeactivateTab.vue'
import HistoryTab from './HistoryTab.vue'

export default new Vue({
  data() {
    return {
      currentTab: 'overview',
      id: null,
      row: null,
      originalStr: null
    }
  },
  computed: {
    tabItems() {
      return [
        { value: 'overview', label: 'Geral', component: OverviewTab },
        { value: 'history', label: 'Histórico', component: HistoryTab },
        {
          value: 'deactivate',
          group: 'Operações',
          label: 'Desativar',
          component: DeactivateTab
        }
      ]
    },
    isDirty() {
      return JSON.stringify(this.row) != this.originalStr
    }
  },
  methods: {
    async load(id) {
      this.id = id
      this.row = null
      const row = await Keyboard.findById(id)

      this.originalStr = JSON.stringify(row)
      this.row = row
    },

    async reload() {
      return await this.load(this.id)
    },

    async save(body) {
      await Keyboard.save(body)
      await this.load(this.row.id)
    },

    async deactivate() {
      await Keyboard.delete(this.row.id)
      await this.load(this.row.id)
    }
  }
})
